import { render, staticRenderFns } from "./StatTableCell.vue?vue&type=template&id=33c21cd6&"
import script from "./StatTableCell.vue?vue&type=script&lang=js&"
export * from "./StatTableCell.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports